import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { getDeviceType } from '../../../utils';
import styles from './index.module.css';

interface Props {
  message: string;
}

const LIMIT = 180;

export const MessageInputAlert = (props: Props) => {
  const { message } = props;
  const isInvalid = message.length >= LIMIT;
  const { formatMessage } = useIntl();
  const isMobile = getDeviceType() === 'mobile';

  return isInvalid ? (
    <div className={clsx(styles.alert, isMobile && styles.isMobile)}>
      {formatMessage({ id: 'chat.message-max-length' })}
    </div>
  ) : null;
};
